import { css } from '@emotion/core';

import { DonutPieChart } from './';

const container = (props: React.ComponentProps<typeof DonutPieChart>) => css`
  height: ${props.height || '100%'};
  width: 100%;
  position: relative;
`;

const centerLabel = css`
  margin: 0;
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;

export const style = { container, centerLabel };
